import React, { Component, PropTypes } from 'react';
import FileSelectorGrid from './FileSelectorGrid';
import FileSelectorList from './FileSelectorList';
import ScrollableContainer from 'components/Tasks/ScrollableContainer';
import FileSelectorToolbar from './FileSelectorToolbar';
import { Colors, Units, Shadow } from 'Css';

const css = oxygenCss({
  statusBar: {
    height: 24,
    padding: `0 ${Units.base}px`,
    lineHeight: '24px',
    fontSize: 12,
    backgroundColor: Colors.material.grey[300].hex,
    boxShadow: Shadow[1]
  }
});

class FileSelector extends Component {
  static propTypes = {
    read: PropTypes.func,
    changeDir: PropTypes.func,
    onSelect: PropTypes.func,
    totalItems: PropTypes.number,
    mode: PropTypes.string,
    type: PropTypes.string,
    items: PropTypes.array
  };

  componentWillMount() {
    const { read, type } = this.props;
    read(type);
  }

  handleSelect = item => {
    const { onSelect } = this.props;
    onSelect && onSelect(item);
  };

  render() {
    const { items, mode, totalItems, changeDir, ...other } = this.props;
    const toolbar = (
      <FileSelectorToolbar changeDir={changeDir} mode={mode} {...other} />
    );
    const info = (
      <div className={css.statusBar}>
        {items.length} / {totalItems}
      </div>
    );
    return (
      <ScrollableContainer header={toolbar} footer={info}>
        {mode === 'grid' ? (
          <FileSelectorGrid
            changeDir={changeDir}
            onSelect={this.handleSelect}
            items={items}
          />
        ) : (
          <FileSelectorList
            changeDir={changeDir}
            onSelect={this.handleSelect}
            items={items}
          />
        )}
      </ScrollableContainer>
    );
  }
}

export default FileSelector;



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/FileSelector.js